import React from 'react';
import { Label } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { fetchWorkspaceLocations } from '@/workspaces/actions';
import { findMatch } from '@/utils/resultsHelper';
import fetch from '@/hooks/fetch';
import DatasetConditionDescription from '../components/DatasetConditionDescription';

const WorkspaceLocationsLabelGroup = ({
  datasetCondition,
  fetchData,
  locations,
  readStatus,
}) => {
  fetch.useFetchByCategory(fetchData, 'lookups', readStatus);
  return (
    <DatasetConditionDescription datasetCondition={datasetCondition}>
      <Label.Group className="aridhia-tag">
        {datasetCondition.context.locations.map((name) => {
          const match = findMatch(locations, name, 'value') || { description: name };
          return <Label key={`workspace_location_${name}`} content={match.description} />;
        })}
      </Label.Group>
    </DatasetConditionDescription>
  );
};

export const mapStateToProps = ({
  workspaces: { locations: { lookups: { results, readStatus } } },
}) => ({ locations: results, readStatus });

export const mapDispatchToProps = {
  fetchData: fetchWorkspaceLocations,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceLocationsLabelGroup);
